'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _components = require('../../components');

var _URL = require('../../helpers/URL');

var _ValidateSSO = require('./ValidateSSO.scss');

var _ValidateSSO2 = _interopRequireDefault(_ValidateSSO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateSSO = function (_Component) {
  (0, _inherits3.default)(ValidateSSO, _Component);

  function ValidateSSO() {
    (0, _classCallCheck3.default)(this, ValidateSSO);
    return (0, _possibleConstructorReturn3.default)(this, (ValidateSSO.__proto__ || (0, _getPrototypeOf2.default)(ValidateSSO)).apply(this, arguments));
  }

  (0, _createClass3.default)(ValidateSSO, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = _url2.default.parse(window.location.href, true).query;
      var queryVariable = query.authorizationToken ? 'authorizationToken' : 'token';
      // url.parse decode the query but provider validate the encoded string
      var token = _URL.URL.getUnDecodedQueryVariable(queryVariable);
      window.parent.postMessage({ token: token, operatorId: query.operator_id }, window.location.origin);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _ValidateSSO2.default.validateSSO },
        _react2.default.createElement(_components.LoadingIndicator, { loading: true })
      );
    }
  }]);
  return ValidateSSO;
}(_react.Component);

exports.default = ValidateSSO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ValidateSSO/ValidateSSO.js
// module id = 2027
// module chunks = 0